/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"
import { FaFacebookSquare } from "react-icons/fa"
import { FaInstagram } from "react-icons/fa"
import { FaTwitter } from "react-icons/fa";

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <div>
        <main>{children}</main>
        <footer className="bg-gray-900">
          <div className="container mx-auto flex flex-col md:flex-row items-center px-5 py-6 text-gray-200">
            <div className="flex"><span className="inline-block">© {new Date().getFullYear()}</span> <span className="font-heading inline-block ml-2">Whale Film</span></div>

            <div className="flex items-center md:ml-auto mt-4 md:mt-0">
              <span className="text-sm mr-8 inline-block">Powered by Flickity</span>
              <FaFacebookSquare size="1.75em" className="text-gray-200 mr-3" />
              <FaInstagram size="1.75em" className="text-gray-200 mr-3" />
              <FaTwitter size="1.75em" className="text-gray-200" />
            </div>
          </div>
        </footer>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
